import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";

const categories = [
  {
    key: "妖灵",
    icon: "ri-sparkling-2-line",
    desc: "猫妖、狐妖、樱花精灵……天生带妖气的漂亮女主",
    count: "46 位",
    color: "text-primary-600 bg-primary-100",
  },
  {
    key: "神族",
    icon: "ri-sun-line",
    desc: "凤凰、雪女、九尾狐神族血脉，高贵又神秘",
    count: "28 位",
    color: "text-accent-700 bg-accent-100",
  },
  {
    key: "人类",
    icon: "ri-user-heart-line",
    desc: "普通女孩×妖界，元气打工仔与冷面御姐齐聚",
    count: "31 位",
    color: "text-secondary-700 bg-secondary-100",
  },
  {
    key: "半妖",
    icon: "ri-bear-smile-line",
    desc: "人与妖的混血，身份纠葛中的魅力女主",
    count: "14 位",
    color: "text-primary-700 bg-primary-100",
  },
  {
    key: "魔物",
    icon: "ri-moon-cloudy-line",
    desc: "雾妖、魔灵……带着危险气息的特别存在",
    count: "9 位",
    color: "text-foreground-700 bg-background-200",
  },
];

export default function CharacterCategories() {
  return (
    <section className="bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
        <SectionHeading
          eyebrow="角色分类"
          title="按身份快速筛选女主"
          desc="从妖灵、神族到人类与半妖，按种族与身份把韩国妖精漫画女主分门别类，轻松找到想看的那一位。"
        />
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
          {categories.map((cat) => (
            <Link
              key={cat.key}
              to={`/encyclopedia?race=${encodeURIComponent(cat.key)}`}
              className="group reveal flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-xl ${cat.color}`}>
                <i className={`${cat.icon} text-xl`} aria-hidden="true"></i>
              </span>
              <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{cat.key}女主</h3>
              <p className="mt-1.5 flex-1 text-xs leading-relaxed text-foreground-600">{cat.desc}</p>
              <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700">
                {cat.count}
                <i className="ri-arrow-right-line text-xs" aria-hidden="true"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}